'use client'
import './magicContent.scss'

import Image from 'next/image'
import React, { useCallback, useEffect } from 'react'

import ImageBack1 from '@/src/shared/images/v2/back1.jpg'
import ImageBack2 from '@/src/shared/images/v2/back2.png'
import ImageGirl from '@/src/shared/images/v2/girl.png'
import isTouchEnabled from '@/src/shared/lib/isTouch'

const MagicContent = () => {
  return (
    <div className="intro-magic__center">
      <div className="intro-magic__wrapper">
        <Image
          priority
          data-speed="-3"
          src={ImageBack1}
          quality={30}
          className="layer intro-magic__back1"
          alt="background1"
        />
        <div className="gradient"></div>
        <Image
          priority
          data-speed="-15"
          src={ImageBack2}
          quality={50}
          className="layer intro-magic__back2"
          alt="background2"
        />
        <Image
          priority
          data-speed="-25"
          src={ImageGirl}
          quality={50}
          className="layer intro-magic__girl"
          alt="magic-girl"
        />
      </div>
    </div>
  )
}

const ProviderWrapper = () => {
  const handleParallax = useCallback((event: MouseEvent | Event) => {
    const layers = document.querySelectorAll('.layer') as NodeListOf<HTMLElement>
    const isMouseEvent = event instanceof MouseEvent

    layers.forEach((layer) => {
      const speed = parseFloat(layer.getAttribute('data-speed') || '0')
      const x = isMouseEvent
        ? -((event as MouseEvent).pageX * speed) / 500
        : -(window.scrollY * speed) / 200
      const y = isMouseEvent
        ? -((event as MouseEvent).pageY * speed) / 500
        : -(window.scrollY * speed) / 200

      layer.style.transform = `translateX(${x}px) translateY(${y}px)`
    })
  }, [])

  useEffect(() => {
    const eventType = isTouchEnabled() ? 'scroll' : 'mousemove'
    const eventHandler = handleParallax

    document.addEventListener(eventType, eventHandler)

    return () => {
      document.removeEventListener(eventType, eventHandler)
    }
  }, [handleParallax])

  return <MagicContent />
}

export default ProviderWrapper
